/* =====================================================
   DanaMed — Product Image Auto Slideshow
   Animation: Slide from Top to Bottom
   Interval: 2 seconds per image
   ===================================================== */

(function () {
  'use strict';

  /* ---------- CONFIG — عدّل هون بس ---------- */
  const INTERVAL_MS   = 2000;   // وقت كل صورة بالميلي ثانية (2000 = 2 ثانية)
  const ANIM_DURATION = 600;    // سرعة الأنيميشن بالميلي ثانية
  /* ------------------------------------------ */

  /* CSS الأنيميشن */
  const style = document.createElement('style');
  style.textContent = `
    @keyframes dnmd-slide-in {
      from { transform: translateY(-100%); opacity: 0; }
      to   { transform: translateY(0);     opacity: 1; }
    }
    @keyframes dnmd-slide-out {
      from { transform: translateY(0);    opacity: 1; }
      to   { transform: translateY(100%); opacity: 0; }
    }

    .dnmd-gallery-wrap {
      position: relative;
      overflow: hidden;
    }

    .dnmd-gallery-wrap img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .dnmd-slide-in  { animation: dnmd-slide-in  ${ANIM_DURATION}ms ease forwards; }
    .dnmd-slide-out { animation: dnmd-slide-out ${ANIM_DURATION}ms ease forwards; }

    /* أزرار التنقل */
    .dnmd-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255,255,255,0.85);
      border: 1px solid #ddd;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      font-size: 16px;
      color: #333;
      transition: background 0.2s;
      user-select: none;
    }
    .dnmd-nav:hover { background: rgba(255,255,255,1); }
    .dnmd-nav.prev  { left: 8px; }
    .dnmd-nav.next  { right: 8px; }

    /* نقاط المؤشر */
    .dnmd-dots {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 6px;
      z-index: 10;
    }
    .dnmd-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: rgba(0,0,0,0.25);
      cursor: pointer;
      transition: background 0.3s, transform 0.3s;
    }
    .dnmd-dot.active {
      background: #1a7a5e;
      transform: scale(1.3);
    }
  `;
  document.head.appendChild(style);

  /* -------- الدالة الرئيسية -------- */
  function initSlideshow() {

    /*
      الـ selectors الأكثر شيوعاً في Shopify themes:
      - Dawn / Debut / Sense  →  .product__media-list، media-gallery
      - Prestige / Pipeline   →  .ProductItem__Image
      نجرب كل واحد ونشوف شو موجود
    */
    const candidates = [
      '.product__media-list li',           // Dawn, Sense, Craft
      '.product-single__photos .product-single__photo-wrapper',
      '.thumbnails-wrapper .product-single__photo-wrapper',
      '.product-gallery__image-wrapper',
      '.slick-slide img',
      '.product__media-item',
    ];

    let items = null;
    for (const sel of candidates) {
      const found = document.querySelectorAll(sel);
      if (found.length > 1) { items = found; break; }
    }

    /* إذا ما لقينا عن طريق الـ selectors، نجرب نجمع الصور مباشرة */
    if (!items || items.length < 2) {
      const mediaGallery =
        document.querySelector('.product__media-list') ||
        document.querySelector('[data-product-gallery]') ||
        document.querySelector('.product-images');
      if (!mediaGallery) return;          // مافي gallery، وقف

      items = mediaGallery.querySelectorAll('li, .slide, .product__media-item');
      if (items.length < 2) return;
    }

    /* ---- بنبني الـ slideshow ---- */
    const firstItem  = items[0];
    const container  = firstItem.parentElement;
    let   current    = 0;
    let   timer      = null;
    let   animating  = false;

    /* إخفاء كل العناصر ما عدا الأول */
    items.forEach((el, i) => {
      el.style.position = i === 0 ? 'relative' : 'absolute';
      el.style.top      = '0';
      el.style.left     = '0';
      el.style.width    = '100%';
      if (i !== 0) el.style.opacity = '0';
    });

    container.style.position = 'relative';
    container.style.overflow = 'hidden';
    container.classList.add('dnmd-gallery-wrap');

    /* --- أزرار التنقل --- */
    const btnPrev = document.createElement('button');
    btnPrev.className   = 'dnmd-nav prev';
    btnPrev.innerHTML   = '&#8249;';
    btnPrev.setAttribute('aria-label', 'Previous image');

    const btnNext = document.createElement('button');
    btnNext.className   = 'dnmd-nav next';
    btnNext.innerHTML   = '&#8250;';
    btnNext.setAttribute('aria-label', 'Next image');

    container.appendChild(btnPrev);
    container.appendChild(btnNext);

    /* --- نقاط المؤشر --- */
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'dnmd-dots';
    const dots = Array.from(items).map((_, i) => {
      const d = document.createElement('span');
      d.className = 'dnmd-dot' + (i === 0 ? ' active' : '');
      d.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(d);
      return d;
    });
    container.appendChild(dotsWrap);

    /* ---- دالة الانتقال ---- */
    function goTo(next, direction = 'forward') {
      if (animating || next === current) return;
      animating = true;

      const outEl = items[current];
      const inEl  = items[next];

      /* تحضير العنصر الجديد */
      inEl.style.opacity  = '0';
      inEl.style.position = 'absolute';
      inEl.style.transform = direction === 'forward'
        ? 'translateY(-100%)' : 'translateY(100%)';

      /* اجعله مرئي بدون opacity عشان الـ animation */
      inEl.style.opacity = '1';

      /* أضف الـ classes */
      outEl.classList.add('dnmd-slide-out');
      inEl.classList.add('dnmd-slide-in');

      /* بعد انتهاء الأنيميشن */
      setTimeout(() => {
        outEl.classList.remove('dnmd-slide-out');
        inEl.classList.remove('dnmd-slide-in');

        outEl.style.opacity  = '0';
        outEl.style.position = 'absolute';

        inEl.style.opacity  = '1';
        inEl.style.position = 'relative';
        inEl.style.transform = '';

        /* تحديث الدوت */
        dots[current].classList.remove('active');
        dots[next].classList.add('active');

        current   = next;
        animating = false;
      }, ANIM_DURATION);
    }

    function nextSlide() {
      const next = (current + 1) % items.length;
      goTo(next, 'forward');
    }

    function prevSlide() {
      const prev = (current - 1 + items.length) % items.length;
      goTo(prev, 'backward');
    }

    /* ---- Autoplay ---- */
    function startTimer() {
      timer = setInterval(nextSlide, INTERVAL_MS);
    }
    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    btnNext.addEventListener('click', () => { nextSlide(); resetTimer(); });
    btnPrev.addEventListener('click', () => { prevSlide(); resetTimer(); });

    /* إيقاف مؤقت عند hover */
    container.addEventListener('mouseenter', () => clearInterval(timer));
    container.addEventListener('mouseleave', startTimer);

    startTimer();
    console.log('[DanaMed Slideshow] ✓ Initialized —', items.length, 'images');
  }

  /* ---- تشغيل بعد ما تتحمل الصفحة ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshow);
  } else {
    initSlideshow();
  }

})();